<template>
   <NavView />

  <div class="grid grid-cols-4 gap-4 mt-4">
    <div class="col-span-3 p-4 bg-white rounded-2xl shadow ">
      <FullCalendar :options="calendarOptions" />
    </div>


   <div class="col-span-1 p-4 bg-white rounded-2xl shadow flex flex-col gap-4">
   <div class="flex-1">
      <DateView />
   </div>
        <!-- Section Calendrier Annuel -->
        <div class="flex-1">
            <div class="mb-4">
                <p class="text-blue-900 font-bold text-xl font-serif mb-1">Calendrier académique</p>
                <div class="w-12 h-1 bg-blue-500 rounded-full"></div>
            </div>
            
            <div class="space-y-3">
              
               <div class="flex items-start">
                <div class="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-2"></div>
                 <div>
                      <p class="text-gray-800 font-medium font-serif">Pré-rentrée</p>
                      <p class="text-gray-500 text-xs font-serif">01/10/2024</p>
                      </div>
                  </div>
                
                <div class="flex items-start">
                    <div class="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-2"></div>
                    <div>
                        <p class="text-gray-800 font-medium font-serif">Rentrée</p>
                        <p class="text-gray-500 text-xs font-serif">02/10/2024</p>
                    </div>
                </div>
                
                <div class="flex items-start">
                    <div class="w-2 h-2 bg-red-500 rounded-full mt-2 mr-2"></div>
                    <div>
                        <p class="text-gray-800 font-medium font-serif">Examens</p>
                        <p class="text-gray-500 text-xs font-serif">18/12/2024 - 10/01/2025</p>
                    </div>
                </div>
                
                <div class="flex items-start">
                    <div class="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-2"></div>
                    <div>
                        <p class="text-gray-800 font-medium font-serif">Congés de Noël</p>
                        <p class="text-gray-500 text-xs font-serif">19/12/2024 - 05/01/2025</p>
                    </div>
                </div>
                
                <div class="flex items-start">
                    <div class="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-2"></div>
                    <div>
                        <p class="text-gray-800 font-medium font-serif">Congés de Pâques</p>
                        <p class="text-gray-500 text-xs font-serif">06/04/2025 - 18/04/2025</p>
                    </div>
                </div>
                
                <div class="flex items-start">
                    <div class="w-2 h-2 bg-red-500 rounded-full mt-2 mr-2"></div>
                    <div>
                        <p class="text-gray-800 font-medium font-serif">Examens</p>
                        <p class="text-gray-500 text-xs font-serif">20/05/2025 - 29/05/2025</p>
                    </div>
                </div>
                
                <div class="flex items-start">
                    <div class="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-2"></div>
                    <div>
                        <p class="text-gray-800 font-medium font-serif">Vacances</p>
                        <p class="text-gray-500 text-xs font-serif">29/05/2025 - 01/10/2025</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

 <footer class="nav-container py-4 text-center text-sm text-gray-300 font-serif">
     &copy; 2025 University StudentGate — Tous droits réservés.
   </footer>

</template>

<script>
import axios from 'axios'
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import DateView from '../views/DateView.vue';
import NavView from '../views/NavView.vue';


export default {
  name: 'DashboardView',
  components: {
    FullCalendar,
    DateView,
    NavView,
    
    
  },
  data() {
    return {
      user: null,
      dropdownVisible: false,
      selectedDate: null,
      events: [],
     

    }
  },
  computed: {
    calendarOptions() {
      return {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        height: '100%',
        contentHeight: 'auto', 
         aspectRatio: 1.5, 
    headerToolbar: {
      right: 'prev,next today',
      center: 'title',
      left: 'dayGridMonth,dayGridWeek,dayGridDay'
    },

        events: this.events,
  eventContent: function(arg) {
    const title = arg.event.title;
    const start = arg.event.start;
    const end = arg.event.end;

   
    const formatTime = (date) => {
      return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      });
    };

    const startTime = formatTime(start);
    const endTime = formatTime(end);
    const eventType = arg.event.extendedProps.type;
    const dotColor = eventType === 'examen' ? '#dc2626' : '#3b82f6';
  
    

    return {
      html: `

      <div style="text-align: center; font-size: 12px;">
        <div style="display: flex; justify-content: center; align-items: center; gap: 6px;">
          <div style="width: 8px; height: 8px; border-radius: 50%; background-color: ${dotColor};"></div>
          <div style="font-weight: bold;">${title}</div>
        </div>
        <div style="font-size: 11px; color: #555;">${startTime} - ${endTime}</div>
      </div>


       
      `
    };
  },
      }
    }
  },
  mounted() {
    this.fetchUserAndEvents()
    document.addEventListener('click', this.closeDropdownOnClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeDropdownOnClickOutside)
  },


  methods: {
    fetchUserAndEvents() {
      axios.get('https://mida-back.onrender.com/api/user', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(res => {
        this.user = res.data
        this.fetchEvents(this.user.niveau)
      })
      .catch(err => {
        console.error('Erreur lors du fetch utilisateur :', err)
      })
    },


    fetchEvents() {
  const niveau = localStorage.getItem('niveau'); 

  axios.get(`https://mida-back.onrender.com/api/events?niveau=${niveau}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
  .then(res => {
    this.events = res.data.data.map(event => ({
      title: `${event.titre}`,
      start: event.start,
      end: event.end,
      extendedProps: {
    type: event.type 
  },
  backgroundColor: event.type === 'examen' ? '#dc2626' : '#3b82f6',
  borderColor: event.type === 'examen' ? '#dc2626' : '#3b82f6'
    }))
  })
  .catch(err => {
    console.error('Erreur lors du chargement des événements :', err)
  })
},




    toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible
    },
    closeDropdownOnClickOutside(event) {
      const menu = this.$refs.menuRef
      if (menu && !menu.contains(event.target)) {
        this.dropdownVisible = false
      }
    },
    logout() {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      this.$router.push('/')
    },
    getImageUrl(path) {
      return path ? `https://mida-back.onrender.com/${path}` : '/image/default-users.jpg'
    },
    onDateChange(date) {
      console.log('Date sélectionnée :', date)
    }
  }
}
</script>

<style>
.nav-container {
  background-color: #163767;
}

.fc {
  font-family: 'font-serif';
  color: #163767; 
  font-size: 14px;
}

.fc-toolbar-title {
  color: #163767; 
  font-weight: bold;
  font-family: 'font-serif';
}

.fc-col-header-cell-cushion {
  color: #163767; 
  font-family: 'font-serif';
}
.fc-daygrid-day {
  width: 130px;
}

.fc-col-header-cell {
  width: 120px ; 
}

.fc .fc-toolbar.fc-header-toolbar {
  background-color: white;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 16px;
}


.fc .fc-button {
  background-color: #1e4a8b;
  border: none;
  color: white;
  text-transform: capitalize;
  box-shadow: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-family: 'font-serif', serif;
}

.fc .fc-button:hover {
  background-color: #153a6b;
}

.fc .fc-button-active {
  background-color: #062f64;
}

.fc .fc-button .fc-icon {
  color: white;
}

</style>
